import React from 'react';
import { RegisterForm } from '../components/RegisterForm';
import './Register.css';

export const Register: React.FC = () => {
  return (
    <div className="register-page">
      <div className="register-container">
        <RegisterForm />
      </div>
    </div>
  );
}; 